module.exports = __webpack_public_path__ + "media/images/sales/weddingday/thumb-pricing-02-072d389b23e4ebbd6a8c82c947b2c3d6.svg";